import { Box, Typography } from "@mui/material";
import { RootPage } from "@app/components/RootPage";
import { CarVirtualTable } from "@app/components/VirtualTable";
import { useShowMessage } from "@app/hooks/useShowMessage";
import { CarButton } from "@app/components/Buttons";
import { CarStatusSuccess } from "@app/components/Icons";
import { useDialog } from "@app/hooks/useDialog";
import { InProgressDialog } from "@app/components/InProgressDialog";

export const DebugPage = () => {
  const showMessage = useShowMessage();

  const dialog = useDialog();

  const run = () =>
    dialog(InProgressDialog, {
      message: `The simulation is running.\nPlease wait.`,
      // lastRunTime: 10000,
      run: () => new Promise((r) => setTimeout(r, 20000)),
    });

  return (
    <RootPage>
      <Box sx={{ p: 3 }}>
        <CarButton onClick={() => run()}>Show Message</CarButton>
        <CarVirtualTable
          sx={{
            width: "100%",
            height: "calc(100vh - 200px)",
          }}
          columnCount={1000}
          rowCount={1000}
          onRenderCell={(col, row) => `${col} ${row}`}
          onRenderColumnHeader={(col) => `Header ${col}`}
          onRenderRowHeader={(row) => `Row ${row}`}
          onRenderColumnRowHeader={() => "Test"}
        />
      </Box>
    </RootPage>
  );
};
